<template>
  <Container>

    <div class="border p-4 mb-4">

      <button class="btn btn-primary mr-2" @click="oneClick()">Btn</button>

      <button class="btn btn-primary mr-2" @click="getBalance()">Btn balance</button>
    </div>

    <div class="border p-4 mb-4">
      <h4>读取地址</h4>
      <hr>
      {{$store.state.web3.account}}
    </div>

    <div class="border p-4 mb-4">
      <h4>$store.state.web3</h4>
      <hr>
      <pre>{{$store.state.web3}}</pre>
    </div>
  </Container>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: '',
  components: {},
  props: [],
  data() {
    return {
      
    }
  },
  computed: {},
  watch: {},
  methods: {
    ...mapActions(['getPendingReward','harvest','unStakeLP','getHasStakeBalance','getLPBalance','approveLP','hasApproveLP','stakeLP','addLiquidity','liquidityETHContributed','liquidityTotalETHContributed','claimLPTokensLiquidity']),

    oneClick(){
      let v = this;
      //v.addLiquidity();
      //v.liquidityETHContributed('0x77C8DB3A650362107dE9322850c9F8b2aB6F545A');
      //v.liquidityTotalETHContributed();
      //v.claimLPTokensLiquidity();
      //v.stakeLP('0.345');
      //let b = v.hasApproveLP('0x0A23c22779Cc6d773b95AADF2Ceee173289ACf46');
      //let b =v.hasApproveLP('0x8d41A792Fb3Bc84281ED5Ac80c0e52AC0BA3553c');
      //console.log(b);
      //v.approveLP();
      //v.unStakeLP('0.345');
      //v.harvest();
      //let b = v.getLPBalance('0x0A23c22779Cc6d773b95AADF2Ceee173289ACf46');
      //console.log(b);
      //v.getHasStakeBalance('0x0A23c22779Cc6d773b95AADF2Ceee173289ACf46');
      v.getPendingReward('0x0A23c22779Cc6d773b95AADF2Ceee173289ACf46');
    },
  },
  created() {
    
  },
  //mounted() {},
  //beforeDestroy() {},
  //update() {},
  //activited() {},
  //beforeRouteUpdate() {},
  //filters: {},
};
</script>

<style lang="scss" scoped>
  
</style>